import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/doen/ai-machine/AIMachineHeaderButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Doen/MediaMachine/assets/Apple.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/Doen/MediaMachine/assets/Banana.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/Doen/MediaMachine/assets/Gesture1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/Doen/MediaMachine/assets/Gesture2.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Doen/MediaMachine/MediaMachine.tsx");
